import { runLineAnimationBackwards } from './animations/linesAnimations';
import { isDOMElementInViewport, calculateTitleHeight } from './util';

const ContentHeroBanner = (() => {
    let pathsVisible = false;
    let animationType;

    function isPathsVisible() {
        let svgChildren;

        if (animationType === 'Z-Lines') {
            svgChildren = document.getElementById('zLineAnimation_contentHeroBanner').childNodes;
        } else if (animationType === 'Z-Lines-Two') {
            svgChildren = document.getElementById('zLinesTwoAnimation_contentHeroBanner').childNodes;
        } else if (animationType === 'CurveAnimation') {
            svgChildren = document.getElementById('curveAnimation_contentHeroBanner').childNodes;
        }

        if (svgChildren !== undefined && (animationType === 'Z-Lines' || animationType === 'Z-Lines-Two' || animationType === 'CurveAnimation')) {
            svgChildren.forEach((el) => {
                if (el.style && el.style.opacity === '1') {
                    pathsVisible = true;
                } else if (el.style && el.style.opacity === '0') {
                    pathsVisible = false;
                }
            });
        }
    }

    function runAnimation() {
        const element = document.querySelector('.hero-wrapper-content--redesign');
        if (element) {
            animationType = document.querySelector('.hero-wrapper-content--redesign').dataset.animationtype;
            isPathsVisible();

            if (isDOMElementInViewport(element)) {
                if (animationType === 'Z-Lines' && !pathsVisible) {
                    runLineAnimationBackwards('#zLine1_contentHeroBanner');
                    runLineAnimationBackwards('#zLine2_contentHeroBanner');
                } else if (animationType === 'Z-Lines-Two' && !pathsVisible) {
                    runLineAnimationBackwards('#zLine1Two_contentHeroBanner');
                    runLineAnimationBackwards('#zLine2Two_contentHeroBanner');
                } else if (animationType === 'CurveAnimation' && !pathsVisible) {
                    runLineAnimationBackwards('#curveLine1_contentHeroBanner');
                    runLineAnimationBackwards('#curveLine2_contentHeroBanner');
                }
            }
        }
    }

    return {
        init() {
            runAnimation();
            window.addEventListener('scroll', runAnimation);
            calculateTitleHeight();
        },
    };
})();

export default (() => {
    $(document).ready(ContentHeroBanner.init);
})();
